import AppSettings from "@/settings/appSettings"
import axios, { AxiosInstance } from "axios";


/**
 *  Get api call
 */



const client: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
});


const clientComercial: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Comercial,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientComercialUpload: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_ComercialOdata,
    headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientContabilitate: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Contabilitate,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});


const clientComercialOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_ComercialOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientDocumente: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Documente,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientDocumenteOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_DocumenteOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    }
});

const clientResurseUmane: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_ResurseUmane,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientResurseUmaneOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_ResurseUmaneOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    }
});

const clientAuth: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});
const clientRapoarte: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Rapoarte,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const ApiHeader = {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    }
}


export default {
    client,
    clientComercial,
    ApiHeader,
    clientDocumente,
    clientRapoarte,
    clientComercialOdata,
    clientAuth,
    clientContabilitate,
    clientDocumenteOdata,
    clientResurseUmane,
    clientResurseUmaneOdata,
    clientComercialUpload
}
